export enum Sort {
  all = 'All',
  active = 'Active',
  completed = 'Completed',
}
